export const APP_NAME = 'Building Dashboard'
export const APP_TAGLINE_TH = 'แพลตฟอร์มบริหารจัดการอาคาร'
export const APP_TAGLINE_EN = 'Building Operations Platform'
export const COPYRIGHT_HOLDER = 'Building Dashboard'
export const DEFAULT_TITLE = `${APP_NAME}`

// Modern Industrial palette defaults
export const BRAND_COLORS = {
  primary: '#D97706',
  secondary: '#475569',
  appBar: '#1C1F26',
  background: '#F4F5F7',
  surface: '#FFFFFF',
  error: '#DC2626',
  success: '#059669',
  info: '#0EA5E9',
  warning: '#D97706',
}
